/**
 * Auth reducers index script file
 *
 * @package    Reducers
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import Immutable from 'seamless-immutable';

import { AUTHORIZE_SUCCESS, UN_AUTHORIZE_SUCCESS, CHANGE_ROLE_SUCCESS, KEEP_ALIVE_SUCCESS } from 'Actions/auth';
import { MY_PROFILE_UPDATE_SUCCESS } from 'Actions/user';

export const INITIAL_STATE = Immutable({
    isLoggedIn: false,
    AccessToken: null,
    user: null,
    accessTokenType: null,
});

export default function authReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case AUTHORIZE_SUCCESS:
            return state.merge({
                isLoggedIn: true,
                AccessToken: action.payload.token,
                user: action.payload.user,
                accessTokenType: action.payload.type,
            });

        case KEEP_ALIVE_SUCCESS: {
            const data = action.payload.data;
            if ('activeRole' in data) {
                delete data.activeRole;
            }
            const auth = JSON.parse(localStorage.auth);

            return state.merge({
                user: {...auth.user, ...data},
            });
        }

        case CHANGE_ROLE_SUCCESS:
            return state.merge(
                {
                    user: {
                        activeRole: action.payload,
                    },
                },
                { deep: true }
            );

        case UN_AUTHORIZE_SUCCESS:
            return state.merge({
                isLoggedIn: false,
                AccessToken: null,
                accessTokenType: null,
                user: null,
            });

        case MY_PROFILE_UPDATE_SUCCESS:
            return state.merge(
                {
                    user: action.payload.data,
                },
                { deep: true }
            );

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js